import { Module } from 'vuex'

export interface PartnerState {
    counter: number
  }

export const initialState: PartnerState = {
  counter: 0
}
